"use client"

import { Container, SimpleGrid, Box, Card, Text } from "@forestsync/ui"
import { TbChartBar, TbLeaf, TbTrendingUp, TbWorld } from "react-icons/tb"
import { useTranslations } from "next-intl"
import type { LandingMetrics } from "@/actions/metrics"

function formatCompact(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`
  return String(value)
}

interface LandingStatsBarProps {
  metrics: LandingMetrics
}

export function LandingStatsBar({ metrics }: LandingStatsBarProps) {
  const t = useTranslations("landing.metrics")

  const stats = [
    { icon: TbChartBar, value: String(metrics.activeMarkets), unit: "", label: t("activeMarkets") },
    { icon: TbLeaf, value: formatCompact(metrics.listedVolume), unit: "tCO₂e", label: t("listedVolume") },
    { icon: TbTrendingUp, value: formatCompact(metrics.totalVolume), unit: "tCO₂e", label: t("totalVolume") },
    { icon: TbWorld, value: String(metrics.countriesCount), unit: "", label: t("countriesRepresented") },
  ]

  return (
    <Box py={48} bg="var(--mantine-color-default-hover)">
      <Container size="lg">
        <SimpleGrid cols={{ base: 2, md: 4 }} spacing="lg">
          {stats.map((stat) => (
            <Card key={stat.label} withBorder p="lg" radius="md" ta="center">
              <stat.icon size={28} color="var(--mantine-primary-color-filled)" />
              <Text fw={800} size="xl" mt="xs" c="var(--mantine-color-text)">
                {stat.value}
                {stat.unit && (
                  <Text component="span" size="xs" c="dimmed"> {stat.unit}</Text>
                )}
              </Text>
              <Text c="dimmed" size="sm" mt={4}>{stat.label}</Text>
            </Card>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  )
}
